import { create } from 'zustand';
import apiClient from '../api/client';
import Alertas from '../alerts/AlertasGernericos';
import { filter, find } from 'lodash';

export const useTerminaltore = create((set, get) => ({

    carregando: false,
    vendas_por_terminal_mes_corrente: [],
    qtd_terminais_ativos: 0,
    mostrar_graficos_vendas_por_terminal: true,
    terminais_cadastrados: [],
    dados_terminal_para_edicao: [],
    pagina_atual: 1,
    ultima_pagina: 0,
    id_terminal: 0,
    terminais: [],
    paginaAtual: 1,
    ultimaPagina: 1,
    loading: 'idle',
    deletingId: null,
    errosDeImpressao: [],

    setVendas_por_terminal_mes_corrente: (dados) => set({ vendas_por_terminal_mes_corrente: dados }),
    setQtd_terminais_ativos: (dados) => set({ qtd_terminais_ativos: dados }),


    GetEstatisticasDosTerminais: async () => {
        try {

            const response = await apiClient.get('/GetStatisticasDosTerminais');

            if (!response) {
                throw new Error("Ocorreu um erro de conexão, verifique se você tem acesso a internet.");
            }

            let data = response.data;

            if (data.dados_das_vendas_por_terminais.length == 0) {
                set({ mostrar_graficos_vendas_por_terminal: false })
                return
            }


            set({
                vendas_por_terminal_mes_corrente: data.dados_das_vendas_por_terminais,
                qtd_terminais_ativos: data.qtd_terminais_ativos
            })

        } catch (err) {
            set({ carregando: false, });
            Alertas.ExibirAlertaErro(err.message || "Erro desconhecido durante o login.");
        } finally {
            set({ carregando: false });
        }
    },

    GetTerminais: async () => {
        try {
            const { pagina_atual } = get();

            set({ carregando: true })
            const response = await apiClient.get('/GetTerminais', {
                params: { page: pagina_atual }
            });

            if (!response) {
                throw new Error("Ocorreu um erro de conexão, verifique se você tem acesso a internet.");
            }

            let terminais = response.data.dados.data;
            const ultima_pagina = response.data.dados.last_page;

            set({
                terminais_cadastrados: terminais,
                ultima_pagina: ultima_pagina
            })
            set({ carregando: false })

        } catch (err) {
            set({ carregando: false, });
            Alertas.ExibirAlertaErro(err.message || "Erro desconhecido durante o login.");
        } finally {
            set({ carregando: false });
        }
    },

    PaginarTerminais: async (numero_da_pagina) => {
        const { GetTerminais } = get();
        set({ pagina_atual: numero_da_pagina });
        await GetTerminais();
    },


    /**
     * Busca os terminais de forma paginada.
     * Usado tanto para a carga inicial quanto para a paginação.
     */
    fetchTerminais: async (page = 1) => {
        set({ loading: 'fetching' });
        try {
            const response = await apiClient.get('/GetTerminais', {
                params: { page }
            });
            const { data, last_page, current_page } = response.data.dados;

            set({
                terminais: data,
                ultimaPagina: last_page,
                paginaAtual: current_page,
                loading: 'idle',
            });
        } catch (error) {
            Alertas.ExibirAlertaErro(error.response?.data?.message || "Erro ao buscar terminais.");
            set({ loading: 'idle' });
        }
    },

    /**
     * Busca terminais com base nos filtros fornecidos.
     */
    searchTerminais: async (filtros) => {
        set({ loading: 'searching', paginaAtual: 1 }); // Reseta para a página 1 na busca
        try {
            const response = await apiClient.post('/PesquisarTerminal', {
                nm_maquina: filtros.nm_maquina,
                operador: filtros.operador,
                ativo: filtros.status
            });
            const { data, last_page, current_page } = response.data.dados;

            set({
                terminais: data,
                ultimaPagina: last_page,
                paginaAtual: current_page,
                loading: 'idle'
            });
        } catch (error) {
            Alertas.ExibirAlertaErro(error.response?.data?.message || "Não foi encotrado nenhum terminal com esses dados.");
            set({ loading: 'idle' });
        }
    },

    /**
     * Exclui um terminal.
     */
    deleteTerminal: async (terminalId) => {
        set({ deletingId: terminalId }); // Mostra o loading apenas na linha a ser excluída
        try {
            let response = await apiClient.post('/ExcluirTerminal', { id: terminalId });

            if (!response) {
                throw new Error("Verifque sua conexão");
            }

            const { message, erro } = response.data;

            if (erro) {
                throw new Error(message);
            }

            Alertas.ExibirAlertaSucesso("Terminal excluído com sucesso!");

            // Atualiza a lista de terminais buscando os dados da página atual novamente
            await get().fetchTerminais(get().paginaAtual);

        } catch (error) {
            Alertas.ExibirAlertaErro(error?.message || "Erro ao excluir terminal.");
        } finally {
            set({ deletingId: null });
        }
    },

    /**
     * Atualiza os dados de um terminal.
     */
    updateTerminal: async (terminalData) => {
        set({ loading: 'updating' });
        try {

            const response = await apiClient.post('/AtualizarTerminal', {
                id: terminalData.id,
                nm_maquina: terminalData.nm_maquina,
                operador: terminalData.operador,
                ativo: terminalData.ativo,
                cod_maquina: terminalData.cod_maquina
            });

            if (!response) {
                throw new Error("Ocorreu um erro de conexão, verifique se você tem acesso a internet.");
            }
            const { erro, message } = response.data;

            if (erro) {
                throw new Error(message);
            }

            Alertas.ExibirAlertaSucesso(message);

            // Atualiza a lista
            await get().fetchTerminais(get().paginaAtual);

        } catch (error) {
            Alertas.ExibirAlertaErro(error.message || "Erro ao atualizar terminal.");
            set({ loading: 'idle' });
            return false;
        } finally {
            set({ loading: 'idle' });
        }
    },

    /**
     * Cria um novos terminal.
     */
    CreateTerminal: async (terminalData) => {

        set({ loading: 'creating' });
        try {
            const response = await apiClient.post('/CriarTerminal', {
                id: terminalData.id,
                nm_maquina: terminalData.nm_maquina,
                operador: terminalData.operador,
                ativo: terminalData.ativo
            });

            if (!response) {
                throw new Error("Ocorreu um erro de conexão, verifique se você tem acesso a internet.");
            }
            const { erro, message } = response.data;

            if (erro) {
                throw new Error(message);
            }

            Alertas.ExibirAlertaSucesso(message);
            set({ loading: 'idle' });

            // Atualiza a lista
            await get().fetchTerminais(get().paginaAtual);

        } catch (error) {
            Alertas.ExibirAlertaErro(error.response?.data?.message || "Erro ao atualizar terminal.");
            set({ loading: 'idle' });
            return false;
        }
    },

    BuscarErrosDeImpressao: async () => {
        try {
            const response = await apiClient.get('/GetErrosDeImpressao');
            if (!response) return
            set({ errosDeImpressao: response.data.dados ?? [] })
        } catch (error) {
            console.log("Erro ao buscar erros na impressão.", error)
        }
    },

    ResolverErrosDeImpressao: async (id_do_erro) => {
        try {

            set({ carregando: 'dell', deletingId: id_do_erro })

            const response = await apiClient.delete('/ResolverErroImpressao', {
                data: { id_do_erro }
            });

            if (!response) {
                throw new Error("Verifque sua conexão");
            }

            const { message, erro } = response.data;

            if (erro) {
                throw new Error(message);
            }

            Alertas.ExibirAlertaSucesso(message);

            set({ carregando: 'idle', deletingId: 0 })

        } catch (error) {
            console.log("Erro ao resolver problema de impressão.", error)
            Alertas.ExibirAlertaErro(error?.message || "Erro ao resolver problema de impressão.");
            set({ loading: 'idle' });
        }
    }



}));













